// pattern: Imperative Shell (loads a browser global)

import '../prism.js'
import '../prism.css'

interface PrismApi {
    manual:boolean;
    languages:{ javascript:unknown };
    highlight (text:string, grammar:unknown, language:string):string;
}

const prism = (window as unknown as { Prism:PrismApi }).Prism

// We highlight our own normalized JSON on demand and inject the HTML; the
// vendored bundle's auto-highlightAll on load is unnecessary and could
// reprocess our preview node, so disable it.
prism.manual = true

export function highlightJson (code:string):string {
    return prism.highlight(code, prism.languages.javascript, 'javascript')
}
